import { lazy } from 'react';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import * as locationFeatureApi from '../../services/locationFeatureApi';

const EquipmentForm = lazy(() => import('./EquipmentForm'));
const EquipmentView = lazy(() => import('./EquipmentView'));

const ENABLE_PERSONALIZED_EQUIPMENT = true;

export const equipmentConfig = {
  id: 'equipment',
  resourceType: 'equipment',
  singularName: 'Equipment',
  pluralName: 'Equipment & Amenities',
  icon: FitnessCenterIcon,
  searchable: true,
  enableFavorites: true,
  favoriteResourceType: 'location_feature',
  usePersonalizedList: ENABLE_PERSONALIZED_EQUIPMENT,
  defaultToFavorites: true,
  modalSize: 'md',
  getDisplayName: (item) => item.name || '',
  getInitialState: (data) => ({
    id: data?.id || null,
    name: data?.name || '',
    description: data?.description || '',
    type: data?.type || 'EQUIPMENT',
    category: data?.taxonomy?.category || '',
    sub_type: data?.taxonomy?.sub_type || '',
    identifying_aliases: data?.identifying_aliases || [],
    as_system: data?.user_id === 'system_user',
    user_id: data?.user_id,
    shadows_id: data?.shadows_id || null,
    _isPartial: data?._isPartial || false,
  }),
  api: {
    getAll: async () => {
      const features = await locationFeatureApi.getLocationFeatures({
        scope: ENABLE_PERSONALIZED_EQUIPMENT ? 'personalized' : undefined
      });
      return features;
    },
    create: (data) => {
      const payload = {
        name: data.name,
        description: data.description,
        type: (data.type || 'EQUIPMENT').toUpperCase(),
        identifying_aliases: data.identifying_aliases || [],
        taxonomy: {
          category: data.category || 'OTHER',
          sub_type: data.sub_type || null
        },
        as_system: !!data.as_system
      };
      return locationFeatureApi.createLocationFeature(payload);
    },
    update: (id, data) => {
      const payload = {
        name: data.name,
        description: data.description,
        type: (data.type || 'EQUIPMENT').toUpperCase(),
        identifying_aliases: data.identifying_aliases || [],
        taxonomy: {
          category: data.category || 'OTHER',
          sub_type: data.sub_type || null
        },
        as_system: !!data.as_system
      };
      return locationFeatureApi.updateLocationFeature(id, payload);
    },
    delete: locationFeatureApi.deleteLocationFeature,
    getById: locationFeatureApi.getLocationFeatureById,
  },
  getDeleteWarning: () => "Deleting this item from the library will also remove it from any locations it's assigned to.",
  FormComponent: EquipmentForm,
  ViewComponent: EquipmentView,
};